import React, { useState, useEffect, useRef } from 'react';
import { Joyride, STATUS, ACTIONS } from 'react-joyride';
import { useIntl } from 'react-intl';

const GuidedTour = ({ runTour, onTourEnd, steps: customSteps }) => {
  const intl = useIntl();
  const [run, setRun] = useState(false);
  const tourEndedRef = useRef(false);

  useEffect(() => {
    if (runTour) tourEndedRef.current = false;
    setRun(runTour);
  }, [runTour]);

  const steps = customSteps || [];

  const handleJoyrideCallback = (data) => {
    const { status, action } = data;

    const isDone =
      status === STATUS.FINISHED ||
      status === STATUS.SKIPPED ||
      action === ACTIONS.CLOSE ||
      action === ACTIONS.SKIP;

    if (isDone && !tourEndedRef.current) {
      tourEndedRef.current = true;
      setRun(false);
      if (onTourEnd) onTourEnd();
    }
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous={true}
      showProgress={true}
      showSkipButton={true}
      onEvent={handleJoyrideCallback}
      disableOverlayClose={false}
      spotlightClicks={true}
      styles={{
        options: {
          primaryColor: '#009688',
          zIndex: 10000,
        },
      }}
      locale={{
        back: intl.formatMessage({ id: 'tour.button.back' }),
        close: intl.formatMessage({ id: 'tour.button.close' }),
        last: intl.formatMessage({ id: 'tour.button.last' }),
        next: intl.formatMessage({ id: 'tour.button.next' }),
        skip: intl.formatMessage({ id: 'tour.button.skip' }),
      }}
    />
  );
};

export default GuidedTour;

